import sessionStore from 'client/Session/SessionStore';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {applyFilters} from 'components/PracticeView/PracticeViewToolbar/Filters/filters.utils';
import {applySort} from 'components/PracticeView/PracticeViewToolbar/Sort/sort.utils';

export const getQuestionSetsQuery = (assignmentId) => {
  const query = resource('question_sets_v1')
    .mandarkEndpoint(['assignments_v3', assignmentId, 'question_sets_v1'])
    .include('subject_v2')
    .include('questions_v3.standards_v1.standard_set_v1')
    .include('questions_v3.question_set_v1.tags_v1')
    .include('questions_v3.question_set_v1.subject_v2')
    .withMeta('question_set_v1,question_v3')
    .customQuery({
      meta: {
        context: {
          user: {
            id: sessionStore.getUserId(),
            role: 'teacher'
          },
          assignment: {
            id: assignmentId
          }
        }
      },
      page: {
        page_size: 20
      }
    });

  return applyFilters(applySort(query, 'meta.assignment_position'));
};

export const getAssignment = (assignmentId) => {
  return resource('assignments_v3')
    .mandarkEndpoint(['assignments_v3', assignmentId])
    .include('classrooms_v1')
    .getResourcePromise();
};

export const getAssignmentsQuery = (assignmentId, studentId) => {
  const query = resource('assignments_v3')
    .mandarkEndpoint(['assignments_v3', assignmentId])
    .customQuery(
      {
        meta: {
          context: {
            student: {
              id: studentId
            },
            user: {
              id: studentId
            }
          }
        }
      },
      studentId
    )
    .include('classrooms_v1')
    .withMeta('assignment_v3');
  return query;
};
